import React, { useContext, useState } from "react";
import _ from "lodash";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { StateContext } from "../../contexts/StateContext";
import { createOrder } from "../../api/api-pizza.js";
import { update } from "../../api/api-user";
import { totalPrice } from "../../helper/functions";
import Address from "./Address";
import Cart from "../Cart/Cart";

const Order = () => {
  const {
    cart,
    setCart,
    user,
    setUser,
    setShowLoginModal,
    setShowOrder,
    setShowOrderHistory,
  } = useContext(StateContext);
  const [selectedAddr, setSelectedAddr] = useState([true, false, false]);
  const [selectedAddrID, setSelectedAddrID] = useState(0);
  const [paymentType, setPaymentType] = useState("credit-card");
  const [notesText, setNotesText] = useState("");

  const selectAddr = (i) => {
    const newSelectedAddr = Array(3).fill(false);
    newSelectedAddr[i] = true;
    setSelectedAddr(newSelectedAddr);
    setSelectedAddrID(i);
  };

  const deleteAddr = async (i) => {
    setSelectedAddr([true, false, false]);
    let newUser = _.cloneDeep(user);
    newUser.addresses = user.addresses.filter((_, idx) => idx !== i);
    setUser(newUser);
    try {
      await update(user._id, newUser);
    } catch (err) {
      console.log(err);
    }
  };

  const addAddr = async (addr) => {
    const newUser = _.cloneDeep(user);
    newUser.addresses.push(addr);
    setUser(newUser);
    try {
      await update(user._id, newUser);
    } catch (err) {
      console.log(err);
    }
  };

  const createOrderHandler = async () => {
    try {
      const newOrder = {
        userId: user._id,
        address: user.addresses[selectedAddrID],
        payment: paymentType,
        notes: notesText,
        cart: cart,
        price: totalPrice(cart),
      };
      await createOrder(newOrder);
      setShowLoginModal(false);
      setShowOrder(false);
      setShowOrderHistory(false);
      setCart({
        items: [],
        delivery: 5,
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="h-100 scrollable overflow-auto m-0">
      <Col className="m-auto" style={{ width: "80%" }}>
        <Card className="mt-2">
          <Row className="m-0">
            <h5 className="align-middle mt-1 text-success">
              Address to deliver
            </h5>

            <hr className="border border-dark" />
            <Row className="m-auto pb-3">
              {user?.addresses &&
                [...Array(3)].map((_, i) => (
                  <Address
                    address={user.addresses[i]}
                    selected={selectedAddr[i]}
                    selectAddr={selectAddr}
                    deleteAddr={deleteAddr}
                    addAddr={addAddr}
                    key={i}
                    i={i}
                  />
                ))}
            </Row>
          </Row>
        </Card>
        <Card className="mt-2">
          <Row className="m-0 mt-1">
            <Col xs={2}>
              <h5 className="mt-1 text-success">Payment</h5>
            </Col>
            <Col xs={10} className="mt-2">
              <Form>
                <Form.Check
                  inline
                  defaultChecked
                  label="Credit card"
                  name="payment"
                  type="radio"
                  id="credit-card"
                  onChange={() => setPaymentType("credit-card")}
                />
                <Form.Check
                  inline
                  label="Upon delivery"
                  name="payment"
                  type="radio"
                  id="delivery"
                  onChange={() => setPaymentType("delivery")}
                />
                <Form.Check
                  inline
                  label="Paypal"
                  name="payment"
                  type="radio"
                  id="paypal"
                  onChange={() => setPaymentType("paypal")}
                />
              </Form>
            </Col>
          </Row>
          <Row className="m-0">
            <hr className="border border-dark" />
          </Row>
          <Row className="m-0">
            <Cart checkout={true} />
            <Row>
              <Col xs={2}>Notes:</Col>
              <Col xs={10}>
                <input
                  style={{
                    width: "100%",
                    height: "80px",
                    borderRadius: "5px",
                    border: "1px solid grey",
                  }}
                  placeholder="Any additional notes"
                  value={notesText}
                  onChange={(e) => setNotesText(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="justify-content-center mt-2">
              <Col xs={3}>
                <Button
                  variant="outline-primary"
                  className="float-end mb-4"
                  style={{ color: "red" }}
                  onClick={() => setShowOrder(false)}
                >
                  CANCEL
                </Button>
              </Col>
              <Col xs={3}>
                <Button
                  variant="outline-primary"
                  className="float-end mb-4"
                  disabled={
                    cart.items.length === 0 || user?.addresses?.length === 0
                  }
                  onClick={createOrderHandler}
                >
                  ORDER
                </Button>
              </Col>
            </Row>
          </Row>
        </Card>
      </Col>
    </div>
  );
};

export default Order;
